/*
  Brandkit (15 okt 2026, wens Cris): bewaking van het cadeauproduct "Cadeau: autoparfum-clip" (€0).
  Het cadeau hoort alleen in de winkelwagen bij minimaal 10 parfumflacons (handles "travel-…"), en maximaal 1 keer.
  Klopt dat niet meer (flacons verwijderd, aantal verhoogd, los toegevoegd), dan zet dit script het cadeau terug
  naar 1 of haalt het weg, en ververst de lade of de winkelwagenpagina. cart.js, cart-drawer.js en global.js blijven ongewijzigd.
  15 okt 2026 (akkoord Cris "Ja, bouwen"): ook de bundeldeals uit "Maak je bestelling compleet" (korting "Bundeldeal 50%").
  "Deal: parfum" (deal-parfum) mag bij 3–9 flacons, "Deal: autoparfum-clip" (deal-autoparfum-clip) bij 5–9 flacons,
  elk maximaal 1. Deals tellen niet mee als flacon (hun handle begint niet met "travel-").
  Later op 15 okt: de parfumdeal alleen in 10 ml; een 30 ml-dealregel wordt weggehaald.
*/
(function () {
  if (window.aaCadeauBound) return;
  window.aaCadeauBound = true;

  var GIFT_HANDLE = 'cadeau-autoparfum-clip';
  var MIN_FLACONS = 10;
  /* handle → [minimaal, maximaal] aantal parfumflacons waarbij de deal mag */
  var DEALS = { 'deal-parfum': [3, 9], 'deal-autoparfum-clip': [5, 9] };
  var busy = false;

  function check() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var flacons = 0;
        var groups = {};
        var extra = {};
        groups[GIFT_HANDLE] = [];
        Object.keys(DEALS).forEach(function (h) { groups[h] = []; });
        (cart.items || []).forEach(function (item) {
          /* "Deal: parfum" alleen in 10 ml (wens Cris "en voor parfum niet de 30ml"): een 30 ml-dealregel gaat weg */
          if (item.handle === 'deal-parfum' && /30/.test(item.variant_title || '')) { extra[item.key] = 0; return; }
          if (groups[item.handle]) groups[item.handle].push(item);
          else if (item.handle && item.handle.indexOf('travel-') === 0) flacons += item.quantity;
        });
        var allowed = {};
        allowed[GIFT_HANDLE] = flacons >= MIN_FLACONS ? 1 : 0;
        Object.keys(DEALS).forEach(function (h) {
          allowed[h] = flacons >= DEALS[h][0] && flacons <= DEALS[h][1] ? 1 : 0;
        });
        var updates = extra;
        var change = Object.keys(extra).length > 0;
        Object.keys(groups).forEach(function (h) {
          groups[h].forEach(function (g, i) {
            var want = i === 0 ? allowed[h] : 0;
            if (g.quantity !== want) { updates[g.key] = want; change = true; }
          });
        });
        if (!change) return null;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(refresh);
      })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function refresh() {
    if (/^\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function' || typeof drawer.renderContents !== 'function') return;
    var ids = drawer.getSectionsToRender().map(function (s) { return s.id; });
    return fetch(window.location.pathname + '?sections=' + ids.join(','))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = sections;
          drawer.renderContents(cart);
          if (cart.item_count === 0) drawer.classList.add('is-empty');
        });
      });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(check, 50); });
  }
  document.addEventListener('DOMContentLoaded', check);
  if (document.readyState !== 'loading') check();
})();
